import type { ReactElement } from 'react';
import { Layout } from './layout';


export const Archive = (): ReactElement => (
  <Layout />
);
